import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=c7480850&scoped=true&lang=pug&"
import script from "./Cell.vue?vue&type=script&lang=js&"
export * from "./Cell.vue?vue&type=script&lang=js&"
import style0 from "./Cell.vue?vue&type=style&index=0&id=c7480850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7480850",
  null
  
)

export default component.exports